<div class="modal-page" [class.allowSafeArea]="allowSafeArea()" [ngClass]="backgroundColorPairClass()">
    @if (showHeader()) {
        <div class="page-header"
             [ngClass]="{
                'with-content': showContent,
                'page-alignment-top': page.containerComponentRef.instance.pageSpec.geometry.alignment === PageAlignment.TOP
             }">
            <div class="page-header-main">
                @if (showLeftRefreshButton()) {
                    <woa-icon-button class="page-header-main-button refresh" [type]="IconButtonType.REFRESH"
                                     (onActivate)="onRefresh.emit()"></woa-icon-button>
                }
                @if (showLeftCloseButton()) {
                    <woa-icon-button class="page-header-main-button close" [type]="IconButtonType.CLOSE"
                                     (onActivate)="close()"></woa-icon-button>
                }
                <ng-content select="[slot=header-left]"></ng-content>
                @if (title() || subtitle) {
                    <div class="page-header-main-heading"
                         [ngClass]="{
                             'button-left': showLeftRefreshButton() || showLeftCloseButton(),
                             'button-right': showRightRefreshButton() || showRightCloseButton()
                         }">
                        <div class="page-header-main-heading-titles">
                            @if (title()) {
                                <div class="page-header-main-heading-titles-title"
                                     [ngClass]="{'with-subtitle': subtitle()}">
                                    {{ title() | translate: translationParams() }}
                                </div>
                            }
                            @if (showSubtitle() && subtitle) {
                                <div class="page-header-main-heading-titles-subtitle">
                                    {{ subtitle() | translate: translationParams() }}
                                </div>
                            }
                        </div>
                    </div>
                }
                <ng-content select="[slot=header-right]"></ng-content>
                @if (showCancelLink()) {
                    <woa-link [link]="'woa.button.common.cancel'" [underlined]="false" [plain]="true"
                              (onActivate)="close()"></woa-link>
                }
                @if (showRightRefreshButton()) {
                    <woa-icon-button class="page-header-main-button refresh" [type]="IconButtonType.REFRESH"
                                     (onActivate)="onRefresh.emit()"></woa-icon-button>
                }
                @if (showRightCloseButton()) {
                    <woa-icon-button class="page-header-main-button close" [type]="IconButtonType.CLOSE"
                                     (onActivate)="close()"></woa-icon-button>
                }
            </div>
            <ng-content select="[slot=header]"></ng-content>
        </div>
    }
    @if (showContent()) {
        <div class="page-content" #scroller>
            @if (contentMessages()?.length) {
                <div class="page-content-messages">
                    <ng-content select="woa-content-message"></ng-content>
                </div>
            }
            <div class="page-content-body">
                @if (contentText()) {
                    <div class="page-content-body-text"
                         [innerHTML]="contentText() | translate: translationParams() | html"></div>
                }
                <ng-content></ng-content>
            </div>
        </div>
    }
    @if (showFooter()) {
        <div class="page-footer"
             [ngClass]="{'with-footer-border': showFooterBorder() || (showFooterBorder() === undefined && footerControls().length)}">
            <woa-footer-messages>
                <ng-content select="woa-footer-message" slot="messages"></ng-content>
            </woa-footer-messages>
            <div class="page-footer-main">
                <ng-content select="[slot=footer-start]"></ng-content>
                @if (footerControls().length) {
                    <div class="page-footer-main-controls {{footerControlOrientation()}}">
                        <ng-content select="[woa-page-footer-control]"></ng-content>
                    </div>
                }
                <ng-content select="[slot=footer-end]"></ng-content>
            </div>
        </div>
    }
</div>
